import { lazy } from 'react';

import LoadingButton from '@zenbusiness/zui/LoadingButton';
import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import ListWrapper from '../ListWrapper';
import EmptyStatement from './components/EmptyStatement';

const ListStatement = lazy(() => import('./components/ListStatement'));

export default function MonthlyStatementsTab({
  yearStatements,
  hasNextPagination,
  loading,
  isEmpty,
  handleLoadMore
}) {
  return (
    <ListWrapper direction="column">
      {isEmpty ? <EmptyStatement /> : <ListStatement yearStatements={yearStatements} />}
      {hasNextPagination && (
        <Stack
          direction="row"
          justifyContent="center"
          mb="20px"
        >
          <LoadingButton
            loading={loading}
            onClick={handleLoadMore}
            variant="outlined"
          >
            Load more
          </LoadingButton>
        </Stack>
      )}
    </ListWrapper>
  );
}

MonthlyStatementsTab.propTypes = {
  hasNextPagination: PropTypes.bool.isRequired,
  yearStatements: PropTypes.arrayOf(
    PropTypes.shape({
      year: PropTypes.string.isRequired,
      statements: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          month: PropTypes.string.isRequired,
          last4Digits: PropTypes.string.isRequired,
          unitAccountId: PropTypes.string
        })
      ).isRequired
    })
  ).isRequired,
  loading: PropTypes.bool.isRequired,
  handleLoadMore: PropTypes.func.isRequired,
  isEmpty: PropTypes.bool.isRequired
};
